import QRCode from 'qrcode';

export default function (element, data) {
    const link = data.link || null;
    if (!link) return;

    QRCode.toString(link, {
        type: 'svg',
        width: 180,
        margin: 2
    }, function (err, svg) {
        if (err) return console.error(err);
        element.innerHTML = svg;
    });
}